/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../../Configuration';
import { State } from '../../model/State';

// Services
import { AlarmServiceProvider } from './service/AlarmServiceProvider';
import { AlarmSourceServiceProvider } from './service/AlarmSourceServiceProvider';
import { AlarmCodeServiceProvider } from './service/AlarmCodeServiceProvider';
import { AlarmTypeServiceProvider } from './service/AlarmTypeServiceProvider';

// Components
import { alarmListComponent } from './component/AlarmList';
import { alarmViewComponent } from './component/AlarmView';
import { alarmSourceListComponent } from './component/AlarmSourceList';
import { alarmSourceViewComponent } from './component/AlarmSourceView';
import { alarmCodeListComponent } from './component/AlarmCodeList';
import { alarmCodeViewComponent } from './component/AlarmCodeView';
import { alarmTypeListComponent } from './component/AlarmTypeList';
import { alarmTypeViewComponent } from './component/AlarmTypeView';

angular.module('serfimtic.gmao.alarm', ['ui.router', 'ngResource'])
.provider('alarmService', AlarmServiceProvider)
.provider('alarmCodeService', AlarmCodeServiceProvider)
.provider('alarmSourceService', AlarmSourceServiceProvider)
.provider('alarmTypeService', AlarmTypeServiceProvider)
.component('alarmList', alarmListComponent)
.component('alarmView', alarmViewComponent)
.component('alarmSourceList', alarmSourceListComponent)
.component('alarmSourceView', alarmSourceViewComponent)
.component('alarmCodeList', alarmCodeListComponent)
.component('alarmCodeView', alarmCodeViewComponent)
.component('alarmTypeList', alarmTypeListComponent)
.component('alarmTypeView', alarmTypeViewComponent)
.config($stateProvider => {
    /** @ngInject */
    $stateProvider
        .state(State.abstractUrlState('gmao.alarm', '/alarm', ['USER']))
        .state(State.componentStateWithFilter('gmao.alarm.list', 'alarmList', '/list', 'ui.alarm.list',
            undefined, ['ADMIN', 'ALARM_READ']))
        .state(State.componentState('gmao.alarm.create', 'alarmView', '/create', 'ui.alarm.creation',
            undefined, ['ADMIN', 'ALARM_CREATE']))

        .state(State.abstractUrlState('gmao.alarm.source', '/source', ['ADMIN']))
        .state(State.componentState('gmao.alarm.source.list', 'alarmSourceList', '/list',
            'ui.alarmsource.list'))
        .state(State.componentState('gmao.alarm.source.create', 'alarmSourceView', '/create',
            'ui.alarmsource.creation'))
        .state(State.componentState('gmao.alarm.source.update', 'alarmSourceView', '/update/:id',
            'ui.alarmsource.update'))

        .state(State.abstractUrlState('gmao.alarm.code', '/code', ['ADMIN']))
        .state(State.componentState('gmao.alarm.code.list', 'alarmCodeList', '/list',
            'ui.alarmcode.list'))
        .state(State.componentState('gmao.alarm.code.create', 'alarmCodeView', '/create',
            'ui.alarmcode.creation'))
        .state(State.componentState('gmao.alarm.code.update', 'alarmCodeView', '/update/:id',
            'ui.alarmcode.update'))

        .state(State.abstractUrlState('gmao.alarm.type', '/type', ['ADMIN']))
        .state(State.componentState('gmao.alarm.type.list', 'alarmTypeList', '/list',
            'ui.alarmtype.list'))
        .state(State.componentState('gmao.alarm.type.create', 'alarmTypeView', '/create',
            'ui.alarmtype.creation'))
        .state(State.componentState('gmao.alarm.type.update', 'alarmTypeView', '/update/:id',
            'ui.alarmtype.update'));
})
.config(alarmServiceProvider => {
    /** @ngInject */
    alarmServiceProvider.setResourceUrl(Configuration.ALARM_PATH);
})
.config(alarmSourceServiceProvider => {
    /** @ngInject */
    alarmSourceServiceProvider.setResourceUrl(Configuration.ALARM_SOURCE_PATH);
})
.config(alarmCodeServiceProvider => {
    /** @ngInject */
    alarmCodeServiceProvider.setResourceUrl(Configuration.ALARM_CODE_PATH);
})
.config(alarmTypeServiceProvider =>  {
    /** @ngInject */
    alarmTypeServiceProvider.setResourceUrl(Configuration.ALARM_TYPE_PATH);
});



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/alarm/AlarmModule.js